import React, { useState, useEffect } from 'react'
import cx from 'classnames'
import Button from '../../components/Button/Button'
import { connect } from 'react-redux'
import { Input } from 'reactstrap'
import { TextField } from '../../components/TextField/TextField'
import { savePremiumPlan, getPremiumPlan } from '../../reduxSetup/action'
import styles from './PremiumPlan.module.scss'

const PremiumPlan = ({ savePremiumPlan, getPremiumPlan, premiumPlans }) => {
  const allPlans = typeof premiumPlans?.allPlans[0] === 'string' ? null : premiumPlans?.allPlans[0]
  const [name, setName] = useState('')
  const [findname, setFindname] = useState('')
  const [price, setPrice] = useState('')
  const [benefits, setBenefits] = useState([''])
  const [mainBenefit, setMainBenefit] = useState('')
  const [validationError, setValidationError] = useState([]);
  const [key, setKey] = useState('')
  const firstBenefit = [...benefits];
  const lastBenefit = firstBenefit.pop();
  const addFieldObject = (setState, items) => {
    const updatedItems = [...items];
    updatedItems.push('');
    setState(updatedItems);
  }
  const changeMultipleFieldsArray = (
    itemValue,
    index,
    setState,
    items
  ) => {
    const updatedItems = [...items];
    updatedItems[index] = itemValue;
    setState(updatedItems.filter((i) => i != ""));
  }
  const submitPlan = () => {
    savePremiumPlan({ name, price, benefits, mainBenefit, key })
    setName('')
    setPrice('')
    setBenefits([''])
    setMainBenefit('')
    setKey('')
    setFindname('')
  }
  const findSubmit = () => {
    getPremiumPlan({ findname })
  }
  useEffect(() => {
    if (allPlans) {
      setName(allPlans?.name)
      setPrice(allPlans?.price)
      setBenefits(allPlans?.benefits)
      setMainBenefit(allPlans?.mainBenefit)
      setKey(allPlans?.key)
    }
    if (!allPlans) return
  }, [premiumPlans])
  return (
    <div className={styles.container}>
      <h2>Add Premium Plan</h2>
      <h6>Find the premium plan by name</h6>
      <div className={cx(styles.form)}>
        <Input
          placeholder="Name"
          onChange={(event) => {
            setFindname(event.target.value);
            setValidationError(
              validationError.filter((errorItem) => errorItem !== "findname")
            );
          }}
          value={findname}
          className={cx(styles.input, {
            [styles.inputError]: validationError.includes("findname"),
          })}
        />
        <Button className={styles.submit} onClick={findSubmit}>Find</Button>
      </div>
      <div className={styles.formContainer}>
        <TextField
          placeholder="Name"
          label="Name*"
          name="name"
          handleChange={(event) => {
            setName(event.target.value);
          }}
          value={name}
        />
        <div>
          <p className={styles.fieldLabel}>Price*</p>
          <Input
            placeholder="Price"
            name="price"
            onChange={(e) => {
              setPrice(parseFloat(e.target.value));
            }}
            value={price}
            className={styles.input}
            type='number'
          />
        </div>

        {
          firstBenefit?.map((val, index) => <div className={styles.fieldContainer} key={index}>
            <div className={styles.fieldLoop}>
              <div className={styles.textareaContainer}>
                <p className={styles.fieldLabel}>Benefit*</p>
                <Input
                  className={cx(styles.textarea)}
                  type="textarea"
                  name="benefit"
                  placeholder="Benefit"
                  onChange={(e) => {
                    changeMultipleFieldsArray(
                      e.target.value,
                      index,
                      setBenefits,
                      benefits
                    );

                  }}
                  value={val}
                />
              </div>
            </div>
          </div>)
        }

        <div className={cx(styles.fieldContainer)}>
          <div className={styles.textareaContainer}>
            <p className={styles.fieldLabel}>Benefit*</p>
            <Input
              className={cx(styles.textarea)}
              type="textarea"
              name="benefit"
              placeholder="Benefit"
              onChange={(e) => {
                changeMultipleFieldsArray(
                  e.target.value,
                  benefits.length - 1,
                  setBenefits,
                  benefits
                );
              }}
              value={lastBenefit}
            />
          </div>
          <Button
            className={styles.plusButton}
            onClick={() => addFieldObject(setBenefits, benefits)}
            disabled={!!lastBenefit && !Object.keys(lastBenefit).length}
          >
            +
          </Button>
        </div>
        <TextField
          placeholder="Main Benefit"
          label="Main Benefit*"
          name="mainBenefit"
          handleChange={(event) => {
            setMainBenefit(event.target.value);
          }}
          value={mainBenefit}
        />
        <Button
          disabled={!name || !price || !benefits.length || !mainBenefit}
          className={styles.sendButton}
          onClick={submitPlan}
        >
          Add
        </Button>
      </div>
    </div>
  )
}
const mapStateToProps = ({ premiumPlans }) => {

  return { premiumPlans };
};

const mapDispatchToProps = {
  savePremiumPlan,
  getPremiumPlan
}
export default connect(mapStateToProps, mapDispatchToProps)(PremiumPlan)